"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var styles = {
  container: {
    padding: function padding(_ref) {
      var spacing = _ref.spacing;
      return spacing(2, 2, 0.5, 2);
    },
    maxWidth: 350,
    '& > .MuiGrid-item': {
      paddingBottom: function paddingBottom(_ref2) {
        var spacing = _ref2.spacing;
        return spacing(1.5);
      }
    }
  },
  placeholderButton: {
    padding: 0,
    lineHeight: 'inherit',
    minWidth: 'auto'
  },
  title: {
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    color: function color(_ref3) {
      var palette = _ref3.palette;
      return palette.grey.main;
    }
  }
};

var PlaceholdersModal = function PlaceholdersModal(_ref4) {
  var open = _ref4.open,
      onClose = _ref4.onClose,
      anchorEl = _ref4.anchorEl,
      placeholders = _ref4.placeholders,
      onInsert = _ref4.onInsert,
      _ref4$loading = _ref4.loading,
      loading = _ref4$loading === void 0 ? false : _ref4$loading;
  return /*#__PURE__*/_react.default.createElement(_material.Popover, {
    open: open,
    onClose: onClose,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    sx: styles.container
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 6,
    sx: styles.title
  }, "Field"), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 6,
    sx: styles.title
  }, "Preview"), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ui.Divider, null)), loading && Array.from({
    length: 11
  }, function (_, idx) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: idx
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      role: "skeleton",
      variant: "text",
      width: 120
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      role: "skeleton",
      variant: "text",
      width: 90
    })));
  }), !loading && placeholders.map(function (placeholder) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: placeholder.value
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
      variant: "text",
      disableRipple: true,
      sx: styles.placeholderButton,
      onClick: function onClick() {
        return onInsert(placeholder);
      }
    }, placeholder.label)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 6,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }, placeholder.value));
  })));
};

var _default = PlaceholdersModal;
exports.default = _default;